import React from 'react';
import './TermsAndConditions.css';

export const TermsAndConditions = () => {
  return (
    <div className="terms-and-conditions-container">
      <section className="terms-and-conditions-wrapper">
        <div className="container">
          <div className="terms-content">
            <h1 className="main-heading">TERMS OF SERVICE</h1>
            <p className="body-text">
              This Terms of Service Agreement (&quot;Agreement&quot;) is entered
              into by and between EDC Squared DMCC, a company registered in the
              United Arab Emirates
              (&quot;EDC&quot;/&quot;us&quot;/&quot;we&quot;) and you
              (&quot;Creator&quot;/&quot;you&quot;).
            </p>
            <br />
            <p className="body-text">
              This Agreement is a legally binding agreement between you and EDC.
              Please read this Agreement carefully and be sure you understand it
              fully. This Agreement describes and controls your legal
              relationship with EDC, the rights you are granting to EDC in any
              photographs, images, vectors, moving images, animations, films,
              videos, audiovisual works or other media together with any
              associated keywords, metadata and/or titles submitted to or shared
              with EDC by you (collectively, &quot;Content&quot;), and the uses
              EDC or its customers may make of the Content.
            </p>

            <h2 className="sub-heading">
              <span>1.</span> Acceptance of Terms
            </h2>

            <p className="body-text">
              By accessing or using EDC&rsquo;s online creative platform at
              edcsquared.io (the &ldquo;Platform&rdquo;) or our related
              websites, services, applications, products and content
              (collectively, the &ldquo;Services&rdquo;), you agree to be bound
              by the terms and conditions set forth in this Agreement.{' '}
              <b>
                If you do not agree to all of these terms and conditions, you
                may not access or use the Platform.
              </b>
            </p>

            <h2 className="sub-heading">
              <span>2.</span> Platform
            </h2>
            <h3 className="sub-section">
              <span>2.1 </span>To access the full functionality of the Platform,
              you must create an account with us in accordance with clause 3.
            </h3>
            <h3 className="sub-section">
              <span>2.2 </span>Subject to the terms of this Agreement, we grant
              you a limited, non-exclusive, non-transferable, and revocable
              license to use the Platform.
            </h3>
            <h3 className="sub-section">
              <span>2.3</span> You must not use the Platform:
            </h3>
            <h4 className="sub-sub-section">
              <span>2.3.1</span> to do or attempt to do anything illegal;
            </h4>
            <h4 className="sub-sub-section">
              <span>2.3.2</span> to do anything that violates applicable
              anti-money laundering, counter terrorist financing, export
              controls and economic sanctions laws or regulations;
            </h4>
            <h4 className="sub-sub-section">
              <span>2.3.3</span> in a way which would reasonably be considered
              to negatively impact the enjoyment of other users of the Platform;
            </h4>
            <h4 className="sub-sub-section">
              <span>2.3.4</span> to engage with minors or vulnerable individuals
              in an exploitative or inappropriate way;
            </h4>
            <h4 className="sub-sub-section">
              <span>2.3.5</span> in any manner as to undermine the
              Platform&rsquo;s operations or security;
            </h4>
            <h4 className="sub-sub-section">
              <span>2.3.6</span> extract any data or content from the Platform
              using any automated system or software; or
            </h4>
            <h4 className="sub-sub-section">
              <span>2.3.7</span> to transmit, or procure the sending of, any
              unsolicited or unauthorised advertising or promotional material or
              any other form of similar solicitation (spam).
            </h4>
            <h4 className="sub-sub-section">
              <span>2.3.8</span> to knowingly transmit any data, send or upload
              any material that contains viruses, Trojan horses, worms,
              time-bombs, keystroke loggers, spyware, adware or any other
              harmful programs or similar computer code designed to adversely
              affect the operation of any computer software or hardware;
            </h4>
            <h4 className="sub-sub-section">
              <span>2.3.9</span> to engage in, or upload any content linked to,
              terrorist activity; or
            </h4>
            <h4 className="sub-sub-section">
              <span>2.3.10</span> using another user's account without
              authorisation.
            </h4>
            <h3 className="sub-section">
              <span>2.4</span> The content on and off the Platform is provided
              for general information only. It is not intended to amount to
              advice or information on which you should rely. You must obtain
              professional or specialist advice before taking, or refraining
              from, any action on the basis of the content on the Platform.
            </h3>
            <h3 className="sub-section">
              <span>2.5</span> Although we make reasonable efforts to update the
              information on our site, we make no representations, warranties or
              guarantees, whether express or implied, that the content on the
              Platform is accurate, complete or up to date.
            </h3>
            <h3 className="sub-section">
              <span>2.6</span> Where the Platform contains links to other sites
              and resources provided by third parties, these links are provided
              for your information only. Such links should not be interpreted as
              approval by us of those linked websites or information you may
              obtain from them.
            </h3>
            <h3 className="sub-section">
              <span>2.7</span> We have no control over the contents of those
              sites or resources.
            </h3>
            <h3 className="sub-section">
              <span>2.8</span> The Platform includes information and materials
              uploaded by other users of the Platform, including to social media
              pages or video-sharing sites. This information and these materials
              have not been verified or approved by us. The views expressed by
              other users on the Platform do not represent EDC's views or
              values.
            </h3>

            <h2 className="sub-heading">
              <span>3.</span> EDC Creator Account
            </h2>
            <h3 className="sub-section">
              <span>3.1</span> To use the Platform and/or Services, you must
              create an account with us ("Creator Account"). It is free to
              create a Creator Account. When you create this account, you must
              provide accurate and up-to-date information. It is important that
              you maintain and promptly update your details and any other
              information you provide to us, to keep such information current
              and complete.
            </h3>
            <h3 className="sub-section">
              <span>3.2 </span>You are responsible for your log-in details to
              your Creator Account and its important to ensure that you keep
              your password to your account secure.
            </h3>
            <h3 className="sub-section">
              <span>3.3 </span>In accordance with this Agreement, you can use
              your Creator Account to:
            </h3>
            <h4 className="sub-sub-section">
              <span>3.3.1</span> Share, upload and/or link your Content to the
              Platform;
            </h4>
            <h4 className="sub-sub-section">
              <span>3.3.2 </span>View specific campaign briefs uploaded to the
              Platform by EDC's brand customers (each a "Customer");
            </h4>
            <h4 className="sub-sub-section">
              <span>3.3.3 </span>Submit Content to be considered for use in
              relation to Customer briefs;
            </h4>
            <h4 className="sub-sub-section">
              <span>3.3.4</span>View and track payments or rewards due to you in
              connection with any Content which has been used by a Customer
            </h4>
            <h3 className="sub-section">
              <span>3.4 </span>With regards to your Creator Account you confirm:
            </h3>
            <h4 className="sub-sub-section">
              <span>3.4.1 </span>you are 18 years of age or over;
            </h4>
            <h4 className="sub-sub-section">
              <span>3.4.2 </span>you will only have one (1) Creator Account;
            </h4>
            <h4 className="sub-sub-section">
              <span>3.4.3 </span>you will not sign up with identification
              documents belonging to another individual, share an account with
              another individual, and/or share content with another EDC creator
              without prior consent from EDC;
            </h4>
            <h4 className="sub-sub-section">
              <span>3.4.4 </span>You are solely responsible for the activity and
              Content on your account;
            </h4>
            <h3 className="sub-section">
              <span>3.5 </span>By creating a Creator Account, you express your
              consent to the EDC Privacy Policy, which is incorporated herein by
              reference and governs EDC&rsquo;s collection, processing, storage
              and transfer of the Content and data submitted by you, including
              data relating to you, your account, your Content or other
              information related to the foregoing (&quot;Personal Data&quot;).
              You agree that your Personal Data may be collected, processed,
              stored, and transferred to jurisdictions other than your home
              jurisdiction.
            </h3>
            <h3 className="sub-section">
              <span>3.6 </span>EDC has the right to refuse to establish an
              account or to close any existing account, for fraud, intellectual
              property infringement, violation of a third party's rights
              including those of privacy or publicity, artificially inflating
              downloads, submission of material that is obscene in nature,
              violent or that might be construed as defamatory, failing to
              comply with EDC's, the Customers or a third party guidelines as
              may be amended from time to time, for any breach of the terms of
              this or for convenience.
            </h3>
            <h3 className="sub-section">
              <span>3.7 </span>If you no longer wish to access the Platform and
              would like to delete your Creator Account you will do this via
              your Creator Account profile settings.
            </h3>
            <h3 className="sub-section">
              <span>3.8 </span>If your Creator Account is terminated for any
              reason, you must obtain written authorisation from EDC prior to
              establishing another creator account. You may not have more than
              one active creator account at any time without the written consent
              of EDC in each instance.
            </h3>

            <h2 className="sub-heading">
              <span>4.</span> Content Submission or Linking
            </h2>
            <h3 className="sub-section">
              <span>4.1</span> You confirm that you are responsible for the
              Content that you make available on or through the Platform and you
              have all the rights needed to create, post or share the Content on
              the Platform and with Customers.
            </h3>
            <h3 className="sub-section">
              <span>4.2</span> EDC has the right to refuse to accept or to
              remove Content from the Platform for any reason. EDC will remove
              Content if EDC believes that such Content may (in EDC's sole
              discretion) subject EDC or any of its officers, managers,
              directors or employees to legal action, the Content violates this
              Agreement, exposes or could expose EDC to disrepute or reflects
              unfavourably on the reputation of EDC or its Customers.
            </h3>
            <h3 className="sub-section">
              <span>4.3</span> Notwithstanding the foregoing and subject to
              EDC's discretion, Content removed by you or opted out by you for
              any reason may be available for license to those customers that
              previously downloaded versions of the removed Content.
            </h3>
            <h3 className="sub-section">
              <span>4.4</span> Licenses issued for any Content that is later
              removed from the Platform will remain in full force and effect in
              perpetuity.
            </h3>
            <h3 className="sub-section">
              <span>4.5</span> You acknowledge and agree that all content
              submitted to the Platform shall comply with the terms of use of
              the third-party social media platform on which it shall be used.
              You warrant that all content submitted to the Platform accordingly
              complies with the terms of use of the third-party social media
              platform. The Platform reserves the right to remove any content
              submitted to the Platform that contravenes such terms.
            </h3>
            <h3 className="sub-section">
              <span>4.6</span> You agree that EDC or its Customers may use your
              Content in relation to advertise and/or market on social media
              platforms including but not limited to Meta, Twitter, TikTok, and
              similar sites and/or applications in accordance with the licenses
              granted in clause 5 (the "Licenses").
            </h3>
            <br />
            <br />

            <h3 className="sub-section">
              <span>4.7</span> You confirm that you have permission to submit to
              the Platform any Content which contains an identifiable face or
              identifiable human figure or other identifiable attribute from
              such individual(s) and that the Content complies with clause 5.
            </h3>
            <h3 className="sub-section">
              <span>4.8</span>You represent and warrant that you will not
              upload, post, or transmit any Content that:
            </h3>
            <h4 className="sub-sub-section">
              <span>4.8.1</span> Infringes any third party's copyrights or other
              intellectual property rights or any right of publicity or privacy;
            </h4>
            <h4 className="sub-sub-section">
              <span>4.8.2</span> contravenes the rules or guidelines of any
              third party social media platform;
            </h4>
            <h4 className="sub-sub-section">
              <span>4.8.3</span> contains any pornographic, defamatory, or
              otherwise obscene, unlawful or immoral content;
            </h4>
            <h4 className="sub-sub-section">
              <span>4.8.4</span> exploits or includes minors or any other group
              of vulnerable people;
            </h4>
            <h4 className="sub-sub-section">
              <span>4.8.5</span> depicts or encourages (expressly or impliedly)
              unlawful or violent acts;
            </h4>
            <h4 className="sub-sub-section">
              <span>4.8.6</span> Depicts or encourages (expressly or impliedly)
              animal cruelty or violence towards animals;
            </h4>
            <h4 className="sub-sub-section">
              <span>4.8.7</span> promotes fraudulent schemes or gives rise to a
              claim of deceptive advertising or unfair competition; or violates
              any law, statute, or regulation.
            </h4>
            <h3 className="sub-section">
              You confirm and agree that in the event that you sign up to the
              Platform through a co-branded webpage with EDC and a Customer you
              will only be able to submit content exclusively for that Customer
              in respect of the specific vertical included in the brief unless
              and until the Customer does not approve any content in a
              continuous period of three (3) months after such time you shall be
              free to submit content for other Customers in the same vertical.
              For the avoidance of doubt nothing in this clause shall restrict
              you from submitting content for Customers in other verticals.
            </h3>

            <h2 className="sub-heading">
              <span>5.</span> Intellectual Property Rights
            </h2>
            <h3 className="sub-section">
              <span>5.1</span> By submitting or sharing any Content to or on the
              Platform, you grant to EDC a non-exclusive, royalty-free,
              irrevocable, perpetual, worldwide, sublicensable, right and
              license to use, distribute, modify, adapt, publish, sell,
              advertise or display any Content uploaded by you for any
              reasonable business purpose, including but not limited to the
              distribution of your Content to EDC's customers, to optimize the
              performance and operation of the Platform and Services, and to
              develop new features and products. You also give permission to EDC
              to add, modify or remove information related to your Content in
              order to manage and license such Content.
            </h3>
            <h3 className="sub-section">
              <span>5.2</span> By submitting or sharing any Content on the
              Platform, you grant a royalty-free, irrevocable, perpetual,
              worldwide, non-exclusive, transferable license for the Customers
              to use the Content for their reasonable business purposes.
            </h3>
            <h3 className="sub-section">
              <span>5.3</span> You further grant EDC a worldwide, non-exclusive,
              royalty-free right to use your name, display name and Content in
              connection with EDC's marketing and promotional activities without
              the payment of any compensation to you. EDC, in its discretion,
              may refrain from any or all of the foregoing without any liability
              to you.
            </h3>
            <h3 className="sub-section">
              <span>5.4</span> You agree, where required, to provide valid and
              accurate model releases for all Content you contribute to EDC that
              contains an identifiable face or identifiable human figure or
              other identifiable attributes including, without limitation,
              voice, appearance, or likeness. You also agree to provide valid
              and accurate property releases to EDC for all Content that
              requires such releases, such determination shall be made in EDC's
              sole discretion. All releases shall be electronically delivered to
              EDC with the Content.
            </h3>
            <h3 className="sub-section">
              <span>5.5</span> You agree that you are solely responsible for
              retaining all original releases and maintaining complete and
              accurate release records.
            </h3>
            <h3 className="sub-section">
              <span>5.6</span> The submission of falsified, inaccurate or
              otherwise defective releases is a material breach of this
              Agreement. Releases submitted by you shall not contain any terms
              inconsistent with this Agreement.
            </h3>
            <h3 className="sub-section">
              <span>5.7</span> You agree that EDC may furnish copies of releases
              to its Customers, as necessary, in order to respond to any
              potential or actual legal action, to comply with applicable laws,
              regulations, and/or union reporting requirements, or any other
              reason EDC deems reasonable in its sole discretion.
            </h3>

            <h2 className="sub-heading">
              <span>6.</span> Creator Responsibilities
            </h2>
            <h3 className="sub-section">
              <span>6.1</span> You represent and warrant as follows:
            </h3>
            <h4 className="sub-sub-section">
              <span>6.1.1</span> you are at least 18 years of age;
            </h4>
            <h4 className="sub-sub-section">
              <span>6.1.2 </span>you will, where requested to do so, provide
              accurate information regarding your residency and/or tax residency
              (where they differ);
            </h4>
            <h4 className="sub-sub-section">
              <span>6.1.3</span> you have the full right, power and authority to
              enter into this Agreement and to fully perform all of your
              obligations hereunder;
            </h4>
            <h4 className="sub-sub-section">
              <span>6.1.4</span> you are under no contractual restriction that
              prevents you from entering into this Agreement;
            </h4>
            <h4 className="sub-sub-section">
              <span>6.1.5</span> the Content and all parts thereof are owned
              and/or controlled by you, unencumbered and original works and are
              capable of copyright protection in all countries where copyright
              or similar protection is available;
            </h4>
            <h4 className="sub-sub-section">
              <span>6.1.6</span> if the Content contains sound recordings, music
              and/or lyrics, you own or have acquired all rights to use such
              sound recordings, music and/or lyrics from the owner of the
              copyright in such sound recordings, music and/or lyrics.
            </h4>
            <h4 className="sub-sub-section">
              <span>6.1.7</span> if the Content consists in whole or in part of
              design elements, fonts, clipart, sprites, vectors, brush tools and
              the like that are included in design programs (e.g., Photoshop,
              Daz, Illustrator), the end user license agreement, terms of
              service or the equivalent license held by you permits you to
              incorporate such elements in the Content and to license such
              Content to EDC and any sub-licensee for the purposes set out in
              this Agreement;
            </h4>
            <h4 className="sub-sub-section">
              <span>6.1.8</span> The Content is neither obscene nor defamatory,
              does not violate any applicable laws and/or regulations, and does
              not infringe the copyright or any other rights of any third party,
              including, without limitation, trademark rights and the rights of
              privacy and publicity; and
            </h4>
            <h4 className="sub-sub-section">
              <span>6.1.9</span> there is no suit action or claim or other legal
              or administrative proceeding now pending or threatened which might
              directly or indirectly affect the Content or which might in any
              way impair the rights granted by you.
            </h4>

            <h2 className="sub-heading">
              <span>7.</span> Payments
            </h2>

            <h3 className="sub-section">
              <span>7.1</span> In consideration of the rights granted to EDC and
              its Customers under this Agreement and for the duration that you
              maintain a Creator Account, EDC will pay you a sum equivalent to
              10% of total ad spend spent on any creative utilising the Content
              (the "Fee"). The Fee will accrue for the duration of the ad spend
              and will be posted in arrears to your EDC wallet (the "Wallet")
              and shall be eligible for payment to you once the balance of the
              Wallet reaches $10 ("Eligible Fee"). For the avoidance of doubt,
              the Fee is deemed inclusive of any taxes if applicable. If the Fee
              is subject to taxes or other payments you agree that you shall
              bear such costs.
            </h3>
            <h3 className="sub-section">
              <span>7.2</span> Subject to provision by EDC, the payment options
              available to you for such Eligible Fee may include but not limited
              be to a bank transfer, vouchers, discounts or such other rewards
              made available through your Creator Account.
            </h3>
            <h3 className="sub-section">
              <span>7.3</span> EDC shall make such payment to you based on the
              elected method of payment on your Creator Account as at the date
              of a qualifying payment processing run.
            </h3>
            <h3 className="sub-section">
              <span>7.4</span> Where such payment is to be made by way of bank
              transfer:
            </h3>
            <h4 className="sub-sub-section">
              <span>7.4.1</span> EDC will make an automatic payment of the
              Eligible Fee to your nominated bank account details being complete
              in your Creator Account on such dates as EDC's payment processing
              run. EDC will endeavour to carry out two (2) payment processing
              runs per month;
            </h4>
            <h4 className="sub-sub-section">
              <span>7.4.2</span> EDC shall make payments to you in US dollars to
              the nominated bank account listed in your Creator Account. Please
              ensure that the details are correct. EDC accepts no responsibility
              of liability for incorrect bank details inputted by you; and
            </h4>
            <h4 className="sub-sub-section">
              <span>7.4.3</span> You will be responsible for any bank fees,
              currency conversion fluctuations or charges incurred in relation
              to your withdrawal.
            </h4>
            <h3 className="sub-section">
              <span>7.5</span> If EDC makes an overpayment to you for any
              reason, EDC shall have the right to deduct the amount of such
              overpayment from your accrued payment or to demand the immediate
              repayment of such overpaid payments or other compensation.
            </h3>

            <h2 className="sub-heading">
              <span>8.</span> Taxes
            </h2>
            <h3 className="sub-section">
              <span>8.1</span> You remain fully responsible for all and any
              direct or indirect taxes, social security charges or payments for
              pensions, or for any other payments, claims, or demands whatsoever
              in connection with any payments made in connection with this
              Agreement which may apply to you depending on your residency,
              location or otherwise, under provision of your jurisdiction. EDC
              will not collect or pay any such taxes or costs on your behalf.
            </h3>
            <h3 className="sub-section">
              <span>8.2</span> You represent and warrant that you comply, and
              will comply at all times, with your obligation under income tax
              provisions in your jurisdiction and you will at all times be
              solely responsible for reporting and remitting any tax liabilities
              arising out of the any payments made in connection with this
              Agreement together with any potential interest or penalties that
              any tax authority may levy as a result of non-compliance and all
              tax-related reporting responsibilities by you to relevant tax
              authorities are entirely your responsibility.
            </h3>
            <h3 className="sub-section">
              <span>8.3</span> If EDC is deemed liable for any taxes, social
              security charges or payments for pensions or for any other
              payments or claims or demands whatsoever relating to the provision
              of and payment in respect of the Content, you will fully indemnify
              and hold EDC harmless in respect of any and all of these claims
              and demands.
            </h3>
            <h3 className="sub-section">
              <span>8.4</span> EDC shall be able to set off such demands against
              any future payments due to you under or in connection with this
              Agreement.
            </h3>

            <h2 className="sub-heading">
              <span>9.</span> EDC's limitation of liability / Disclaimers
            </h2>
            <h3 className="sub-section">
              <span>9.1 </span>YOUR USE OF THE PLATFORM IS AT YOUR OWN RISK. THE
              PLATFORM IS PROVIDED BY OR ON BEHALF OF EDC UNDER THESE TERMS OF
              USE &quot;AS IS&quot; WITHOUT WARRANTY OF ANY KIND, EITHER
              EXPRESS, IMPLIED, STATUTORY OR OTHERWISE.
            </h3>
            <h3 className="sub-section">
              <span>9.2</span> TO THE FULLEST EXTENT PERMITTED BY LAW, EDC
              EXPRESSLY DISCLAIMS ANY AND ALL WARRANTIES OF ANY KIND, WHETHER
              EXPRESS OR IMPLIED, TO EACH AND ANY SERVICE AVAILABLE FROM THE
              PLATFORM, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF
              FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, AND ANY OTHER
              WARRANTY THAT MIGHT ARISE UNDER ANY LAW. WITHOUT LIMITING THE
              FOREGOING, EDC MAKES NO WARRANTY THAT: (I) THE PLATFORM WILL MEET
              YOUR REQUIREMENTS; (II) ACCESS TO THE PLATFORM WILL BE
              UNINTERRUPTED; (III) THE QUALITY OF THE PLATFORM WILL MEET YOUR
              EXPECTATIONS; AND (IV) ANY ERRORS OR DEFECTS IN THE SITE, SERVICES
              OR MATERIALS WILL BE CORRECTED.
            </h3>
            <h3 className="sub-section">
              <span>9.3</span> EDC MAKES NO REPRESENTATIONS OR WARRANTIES THAT
              THE PLATFORM WILL BE PERMITTED IN YOUR JURISDICTION, THAT ANY OF
              YOUR CONTENT SUBMITTED BY YOU WILL BE AVAILABLE THROUGH THE
              PLATFORM OR WILL BE STORED BY THE PLATFORM, THAT THE PLATFORM WILL
              MEET YOUR NEEDS, OR THAT EDC WILL CONTINUE TO SUPPORT ANY
              PARTICULAR FEATURE OF THE PLATFORM.
            </h3>
            <h3 className="sub-section">
              <span>9.4</span> EDC WILL NOT BE LIABLE FOR ANY DAMAGES, INCLUDING
              ACTUAL, INDIRECT, SPECIAL, OR CONSEQUENTIAL DAMAGES ARISING FROM
              THE SUBMISSION OR USE OF YOUR CONTENT, EITHER BY EDC OR ANY
              SUBLICENSEE THEREOF, OR THE TERMINATION OF YOUR CREATOR ACCOUNT.
              YOU EXPRESSLY CONSENT TO ALL THE POTENTIAL USES OF YOUR CONTENT
              CONTEMPLATED HEREBY, AND HAVE NO RIGHT TO DEMAND ANY
              PARTICULARIZED COMPENSATION ARISING FROM ANY INDIVIDUAL OR
              AGGREGATE USAGE.
            </h3>
            <h3 className="sub-section">
              <span>9.5</span> EDC'S TOTAL CUMULATIVE LIABILITY IN CONNECTION
              WITH THIS AGREEMENT AND YOUR USE OF THE PLATFORM, WHETHER IN
              CONTRACT OR TORT OR OTHERWISE, WILL NOT EXCEED THE LESSER OF: (I)
              THE AGGREGATE AMOUNT PAID TO YOU UNDER THIS AGREEMENT IN THE 12
              MONTH PERIOD IMMEDIATELY PRECEDING THE FINAL EVENT GIVING RISE TO
              SUCH LIABILITY; OR (II) $500.
            </h3>
            <h3 className="sub-section">
              <span>9.6</span> THE ABOVE LIMITATIONS AND EXCLUSIONS SHALL APPLY
              TO YOU TO THE FULLEST EXTENT THAT APPLICABLE LAW PERMITS, IN ALL
              ACTIONS OF ANY KIND, WHETHER BASED ON CONTRACT, TORT (INCLUDING,
              WITHOUT LIMITATION, NEGLIGENCE) OR ANY OTHER LEGAL OR EQUITABLE
              THEORY. TO THE EXTENT ANY DISCLAIMER OR LIMITATION OF LIABILITY
              DOES NOT APPLY, ALL APPLICABLE EXPRESS, IMPLIED, AND STATUTORY
              WARRANTIES WILL BE LIMITED IN DURATION TO A PERIOD OF THIRTY (30)
              DAYS AFTER THE DATE ON WHICH YOU FIRST USED THE PLATFORM, AND NO
              WARRANTIES SHALL APPLY AFTER SUCH PERIOD.
            </h3>

            <h2 className="sub-heading">
              <span>10.</span> Termination
            </h2>
            <h3 className="sub-section">
              <span>10.1</span> Either party has the right to terminate this
              Agreement at any time and for any reason.
            </h3>
            <h3 className="sub-section">
              <span>10.3</span> You agree that in the event of termination of
              this Agreement and/or closure of your Creator Account, EDC shall
              no longer be obliged to make any further payments to you following
              payment by EDC of any Eligible Fee payable as at the date of
              termination or the closure of your Creator Account.
            </h3>

            <h2 className="sub-heading">11. Relationship</h2>

            <p className="body-text">
              There is no relationship of partnership, joint venture,
              employment, franchise or agency created hereby between you and
              EDC.
            </p>

            <h2 className="sub-heading">12. Governing Law</h2>

            <p className="body-text">
              This Agreement shall be governed by and construed in accordance
              with the laws of England and Wales.
            </p>

            <h2 className="sub-heading">13. Amendments</h2>

            <p className="body-text">
              EDC reserves the right to amend this Agreement at any time by
              posting the amended terms on the Platform. Your continued use of
              the Platform after such posting will constitute acceptance of the
              amended terms.
            </p>

            <h2 className="sub-heading">14. Entire Agreement</h2>

            <p className="body-text">
              This Agreement constitutes the entire agreement between you and
              EDC with respect to the subject matter hereof and supersedes all
              prior communications and proposals, whether oral or written,
              between you and EDC.
            </p>

            <h2 className="sub-heading">15. Contact Information</h2>

            <p className="body-text">
              If you have any questions about this Agreement, please contact us
              at hello@edcsquared.io.
            </p>
            <br />
            <p className="body-text">Last Updated March 2023</p>
          </div>
        </div>
      </section>
    </div>
  );
};
